<p-divider></p-divider>
<div class="row">
    <h1 class="fsfw">Información</h1>
</div>
<div class="row">
    <div class="p-grid">
        <div class="p-col-12 p-md-6 p-lg-3">
            <i class="pi pi-comment"></i><span class="fsfwsb"> Número de teléfono <p-badge [value]="'i'" pTooltip="Current device phone number in E164 format. Phone number can change over time if you authorize with different account." tooltipPosition="top"></p-badge></span>
            <div class="fsfw">+91 9876543210</div>
        </div>
        <div class="p-col-12 p-md-6 p-lg-3">
            <i class="pi pi-refresh"></i><span class="fsfwsb"> Status <p-badge [value]="'i'" pTooltip="Current device phone number in E164 format. Phone number can change over time if you authorize with different account." tooltipPosition="top"></p-badge></span>
            <div class="fsfw"><img src="https://img.icons8.com/emoji/48/000000/green-circle-emoji.png" width="11"/> Operativo</div>
        </div>
        <div class="p-col-12 p-md-6 p-lg-3">
            <i class="pi pi-comment"></i><span class="fsfwsb"> Session status <p-badge [value]="'i'" pTooltip="Current device phone number in E164 format. Phone number can change over time if you authorize with different account." tooltipPosition="top"></p-badge></span>
            <div class="fsfw"><img src="https://img.icons8.com/emoji/48/000000/green-circle-emoji.png" width="11"/> Autorizado</div>
        </div>
        <!-- <div class="p-col-12 p-md-6 p-lg-3">
            <span class="fsfwsb"> Batería <p-badge [value]="'i'" pTooltip="Device available battery from last synchronization." tooltipPosition="top"></p-badge></span>
            <div class="fsfw"><img src="https://img.icons8.com/external-kiranshastry-gradient-kiranshastry/64/000000/external-battery-multimedia-kiranshastry-gradient-kiranshastry.png" width="15"/> <span>  100%</span></div>
        </div> -->
    </div>
</div>
<!-- <div class="row">
    <h1 class="fsfw">Metrics</h1>
</div>
<div class="row">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <span class="fsfwmb">3 open chats </span>
            <div class="mt-10"><p-progressBar [value]="0" [style]="{'height': '6px'}"></p-progressBar></div>
        </div>
        <div class="p-col-12 p-md-6">
            <span class="fsfwmb">0 group chats </span>
            <div class="mt-10"><p-progressBar [value]="0" [style]="{'height': '6px'}"></p-progressBar></div>
        </div>
        <div class="p-col-12 p-md-6">
            <span class="fsfwmb">0 queued messages </span>
            <div class="mt-10"><p-progressBar [value]="0" [style]="{'height': '6px'}"></p-progressBar></div>
        </div>
        <div class="p-col-12 p-md-6">
            <span class="fsfwmb">1000/1000 Available queue slots </span>
            <div class="mt-10"><p-progressBar [value]="0" [style]="{'height': '6px'}"></p-progressBar></div>
        </div>
    </div>
</div>
<div class="row">
    <h1 class="fsfw">Billing</h1>
</div>
<div class="row">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <span class="fsfwmb14">Plan: Enterprise </span>
        </div>
        <div class="p-col-12 p-md-6">
            <span class="fsfwmb14">Status: Trialing </span>
        </div>
    </div>
</div>
<div class="row">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <span class="fsfwmb14">Test messages <b>0 of ∞</b></span>
            <div class="mt-10"><p-progressBar [value]="0" [style]="{'height': '6px'}"></p-progressBar></div>
        </div>
        <div class="p-col-12 p-md-6">
            <span class="fsfwmb14">Media messages <b>0 of ∞ </b></span>
            <div class="mt-10"><p-progressBar [value]="0" [style]="{'height': '6px'}"></p-progressBar></div>
        </div>
    </div>
</div>
<div class="row">
    <div class="p-grid">
        <div class="p-col-12 p-md-12">
            <span class="fsfwmb14">Current billing period <b>October 7,2021 - October 14, 2021</b></span>
            <div class="mt-10"><p-progressBar [value]="0" [style]="{'height': '6px'}"></p-progressBar></div>
        </div>
    </div>
</div>
<p-divider></p-divider>
<div class="row mt-20">
    <button pButton pRipple type="button" label="Manage Numbers" icon="pi pi-refresh" class="p-button-raised p-button-primary p-button-text fR"></button>
    <button pButton pRipple type="button" label="Back" icon="pi pi-times" class="p-button-raised p-button-secondary p-button-text" (click)="sendCEM()"></button>
</div> -->